<template>
  <div class="amazon-layout">
    <AmazonCopyForm />
    <AmazonCopyResult />
  </div>
</template>

<script setup>
import AmazonCopyForm from '@/components/amazon-copy/AmazonCopyForm.vue'
import AmazonCopyResult from '@/components/amazon-copy/AmazonCopyResult.vue'
</script>
